import { render, staticRenderFns } from "./core-link-item-list-block-edit.vue?vue&type=template&id=09ab8766&"
import script from "./core-link-item-list-block-edit.vue?vue&type=script&lang=js&"
export * from "./core-link-item-list-block-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports